import { useTheme } from "@mui/material";
import { useContext, useState, useRef, useEffect } from "react";
import { ColorModeContext } from "../utils/theme";
import { useNavigate } from "react-router-dom";
import {
    TopBarContainer,
    TopBarInner,
    ThemeToggle,
    ThemeToggleIcon,
    UserMenu,
    UserAvatar,
    UserInfo,
    UserName,
    UserStatus,
    StatusIndicator,
    DropdownContainer,
    DropdownItem
} from "./TopBarStyles";

// import { FiSettings, FiLogOut } from "react-icons/fi";
import { useDispatch } from 'react-redux';
import { logoutUser } from '../store/slices/authSlice';

const TopBar = () => {
    const theme = useTheme();
    const colorMode = useContext(ColorModeContext);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };



    const handleLogoutClick = () => {
        dispatch(logoutUser());
        navigate('/login');
        setIsDropdownOpen(false);
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <TopBarContainer>
            <TopBarInner>
                <ThemeToggle onClick={colorMode.toggleColorMode} type="button" aria-label="Toggle light/dark mode">
                    <ThemeToggleIcon>
                        {theme.palette.mode === 'dark' ? '☾' : '☀'}
                    </ThemeToggleIcon>
                </ThemeToggle>

                <UserMenu onClick={toggleDropdown} ref={dropdownRef} isOpen={isDropdownOpen}>
                    <UserAvatar aria-hidden="true">
                        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 12c2.761 0 5-2.239 5-5s-2.239-5-5-5-5 2.239-5 5 2.239 5 5 5Z" stroke="currentColor" strokeWidth="2" />
                            <path d="M4 21c1.8-4 5-6 8-6s6.2 2 8 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </UserAvatar>
                    <UserInfo>
                        <UserName>Khalil</UserName>
                        <UserStatus><StatusIndicator>Online</StatusIndicator></UserStatus>
                    </UserInfo>

                    {isDropdownOpen && (
                        <DropdownContainer>
                            <DropdownItem onClick={(e) => { e.stopPropagation(); navigate('/profile'); setIsDropdownOpen(false); }}>
                                Profile
                            </DropdownItem>
                            <DropdownItem onClick={(e) => { e.stopPropagation(); handleLogoutClick(); }} style={{ color: '#ef5350' }}>
                                Logout
                            </DropdownItem>
                        </DropdownContainer>
                    )}
                </UserMenu>
            </TopBarInner>
        </TopBarContainer>
    );
};

export default TopBar;